import { Dispatch } from "redux";
import { lang } from "../config/app.config";
import {
  fetchBannerFail,
  fetchBannerRequest,
  fetchBannerSuccess
} from "../store/ActionReducers/banner.actionreducer";
import { httpbase } from "../utils/axios.utils";


export const fetchBanner = (slug:string | undefined = undefined) =>{
  return async (dispatch:Dispatch) =>{
    dispatch(fetchBannerRequest());
    try{
      const banner = '?branch='+slug;
      const response = await httpbase().get(`/banner${slug?banner:'' }&&lang=${lang}`);
      dispatch(fetchBannerSuccess(response.data.data));      
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(fetchBannerFail(e.response.data));
      }
      dispatch(fetchBannerFail("Something went wrong!"));
    }
  }
}